export default "__VITE_ASSET__YwjN$SkH__"